module.exports = __webpack_public_path__ + "routes/login/logoPZ.jpg?053ff8fc";


//////////////////
// WEBPACK FOOTER
// ./routes/login/logoPZ.jpg
// module id = 1827
// module chunks = 0